import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";
import { MsalProvider, useMsal } from "@azure/msal-react";

import App from "./App";
import { msalConfig, loginRequest, silentRequest } from "./authConfig";

const pca = new PublicClientApplication(msalConfig);

function AppLoader() {
    const { instance } = useMsal();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const initializeAuth = async () => {
            // 1. Handle redirect callback if we're returning from loginRedirect
            try {
                await instance.handleRedirectPromise();
            } catch (e) {
                console.error("Redirect error:", e);
            }

            // 2. If there's already an account, we’re done
            const accounts = instance.getAllAccounts();
            if (accounts.length > 0) {
                setLoading(false);
                return;
            }

            // 3. If no account is logged in, try silent SSO
            try {
                await instance.ssoSilent(silentRequest);
                setLoading(false);
            } catch (e) {
                console.warn("Silent SSO failed, redirecting to login:", e);
                // 4. On any silent failure, do a full-page redirect
                instance.loginRedirect(loginRequest);
            }
        };

        void initializeAuth();
    }, [instance]);

    if (loading) {
        return (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#0a2342",
                    margin: 0,
                    padding: 0,
                }}
            />
        );
    }

    return <App />;
}

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
pca.initialize().then(() => {
    root.render(
        <MsalProvider instance={pca}>
            <AppLoader />
        </MsalProvider>
    );
}).catch(e => {
    console.error("MSAL initialization failed:", e);
});